import React from 'react'
import { Box, Checkbox, Stack, Select } from '@/components/lib'

export default function Choice ({ dataType, value, onChange }) {
  const localOnChange = val => {
    let newValue = Object.assign([], value)
    if (dataType?.multiple) {
      if (newValue.includes(val)) {
        newValue.splice(newValue.indexOf(val), 1)
      } else if (val === 'none') {
        newValue = ['none']
      } else {
        if (newValue.includes('none')) {
          newValue.splice(newValue.indexOf('none'), 1)
        }
        newValue.push(val)
      }
    } else {
      if (newValue.includes(val)) {
        newValue = []
      } else {
        newValue = [val]
      }
    }
    onChange(newValue)
  }

  if (!dataType?.multiple && dataType?.showAsDropdown) {
    const selected = value?.[0] ?? ''
    return (
      <Box>
        <Select
          value={selected}
          onChange={e => {
            const val = e.target.value
            onChange(val !== '' ? [val] : [])
          }}
        >
          <option value=''>Select an option...</option>
          {dataType?.options?.map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
          {dataType?.includeNone && <option value='none'>None</option>}
        </Select>
      </Box>
    )
  }

  return (
    <Box>
      <Stack spacing={2}>
        {dataType?.options?.map((option, index) => (
          <Box key={index}>
            <Checkbox checked={value?.includes(option) ?? false} onChange={() => localOnChange(option)}>{option}</Checkbox>
          </Box>))}
        {dataType?.includeNone &&
          <Box>
            <Checkbox color='fg.muted' mr={5} mb={5} isChecked={value?.indexOf('none') > -1} onChange={e => localOnChange('none')}>None</Checkbox>
          </Box>}
      </Stack>
    </Box>
  )
}
